exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gz-filter-box{position:relative;width:100%}.gz-filter-box .gz-input-box{padding:0 24px 0 5px;height:26px;min-height:26px;box-sizing:border-box;font-size:16px;border:1px solid #ccc;border-radius:5px}.gz-filter-box .gz-input-box:focus{outline:none;border-color:#0096d6}.gz-filter-box .gz-input-box::-webkit-input-placeholder{font-style:italic}.gz-filter-box .gz-input-box::-moz-placeholder{font-style:italic}.gz-filter-box .gz-input-box:-ms-input-placeholder{font-style:italic}.gz-filter-box .gz-input-box:-moz-placeholder{font-style:italic}.gz-filter-box .gz-input-box::-ms-clear{display:none}.gz-filter-box .gz-filter-box-icon-container{position:absolute;right:0;top:0;height:100%;width:24px;margin:auto}.gz-filter-box .gz-filter-box-icon-container .gz-filter-box-icon{font-size:16px;line-height:16px;height:16px;width:16px;min-height:16px;min-width:16px;margin:0}.gz-filter-box .gz-filter-box-icon-container.touched{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/filter-box/filter-box.scss
// module id = 108
// module chunks = 0